import { render, staticRenderFns } from "./bebidas.vue?vue&type=template&id=bc8a286c&scoped=true"
import script from "./bebidas.vue?vue&type=script&lang=js"
export * from "./bebidas.vue?vue&type=script&lang=js"
import style0 from "./bebidas.vue?vue&type=style&index=0&id=bc8a286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8a286c",
  null
  
)

export default component.exports